import { CollaboState, CollaboTypes } from '../types/collaboTypes'
import { Reducer } from 'redux'
import { BaseAction } from '../types'
const INITIAL_STATE: CollaboState = {
  all: [],
  activities: [],
  leaderboard: [],
  invites: [],
  searchUser: [],
  createCollaboForm: {
    group_name: '',
    description: '',
    target: '',
    start_date: '',
    end_date: '',
    image: '',
    participants: [],
  },
  inviteForm: {
    saving_type: '',
    main_card: 'new',
    saving_frequency: '',
    start_date: '',
    amount_to_save: '0',
    device: 'mobile',
  },
}

const CollaboReducer: Reducer<CollaboState, BaseAction> = (
  state: CollaboState = INITIAL_STATE,
  action: BaseAction
): CollaboState => {
  switch (action.type) {
    case CollaboTypes.COLLABO_FORM_DATA: {
      return {
        ...state,
        createCollaboForm: {
          ...state.createCollaboForm,
          ...action.payload,
        },
      }
    }

    case CollaboTypes.CLEAR_COLLABO_DATA: {
      return {
        ...state,
        createCollaboForm: { ...INITIAL_STATE.createCollaboForm },
      }
    }

    case CollaboTypes.UPDATE_ACCEPT_INVITE_PAYLOAD: {
      return {
        ...state,
        inviteForm: {
          ...state.inviteForm,
          ...action.payload,
        },
      }
    }

    case CollaboTypes.CLEAR_ACCEPT_INVITE_PAYLOAD: {
      return {
        ...state,
        inviteForm: { ...INITIAL_STATE.inviteForm },
      }
    }

    case CollaboTypes.UPDATE_COLLABO_PARTICIPANTS: {
      return {
        ...state,
        createCollaboForm: {
          ...state.createCollaboForm,
          participants: action.payload,
        },
      }
    }

    case CollaboTypes.GET_ALL_COLLABO_SUCCESS: {
      return {
        ...state,
        all: action.payload,
      }
    }

    case CollaboTypes.GET_COLLABO_ACTIVITIES_SUCCESS: {
      return {
        ...state,
        activities: action.payload,
      }
    }

    case CollaboTypes.GET_COLLABO_LEADERBOARD_SUCCESS: {
      return {
        ...state,
        leaderboard: action.payload,
      }
    }

    case CollaboTypes.GET_COLLABO_INVITES_SUCCESS: {
      return {
        ...state,
        invites: action.payload,
      }
    }
    case CollaboTypes.SEARCH_INVITEE_SUCCESS: {
      return {
        ...state,
        searchUser: action.payload,
      }
    }
    default:
      return state
  }
}

export { CollaboReducer }
